module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.classLevel === 'Bercario' || _vm.classLevel === 'Infantil' || _vm.classLevel === 'Fundamental_1') ? _c('div', {
    staticClass: "form-group"
  }, [_c('h5', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("O aluno compareceu na escola hoje?")]), _vm._v(" "), _c('div', _vm._l((_vm.presence), function(value, key) {
    return _c('label', {
      staticClass: "mt-radio mt-radio-outline"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "presence"
      },
      domProps: {
        "value": key,
        "checked": key === _vm.stdPresence
      },
      on: {
        "change": _vm.putAgendaPresence
      }
    }), _vm._v(_vm._s(value) + "\n\t\t\t"), _c('span')])
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61906a0a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/agenda/presence/StudentPresence.vue
// module id = 1082
// module chunks = 1